define('views/user/register/financial/linkedcardsuccess',["backbone",
         "text!views/user/register/financial/linkedcardsuccess.html",
         "views/_base/baseview",
         "views/user/register/financial/success",
         "models/linkedcards/linkedcard"
], function (Backbone, Template, BaseView, SuccessView, LinkedCard) {
    "use strict";

    return BaseView.extend({
        isRender: true,
        needsAuth: true,
        template: _.template(Template),
        events: {
            "click #saveNickname": "saveNickname",
            "click #finish": "finish"
        },
        tagName: "section",
        id: "linkedCardSuccess",
        initialize: function (options) {
            options = options || {};
            this.EUID = options.EUID;
            this.elementName = options.elementName;
            pf.session.getAuth(function () { });

            //call method to update enrollment
            var data = { GUID: this.EUID };
            $.ajax({
                type: "POST",
                url: pf.consumerURL + "/LinkedCards/PendingEnrollment",
                data: JSON.stringify(data),
                async: true,
                contentType: "application/json; charset=utf-8",
                traditional: true,
                success: function (response) {
                },
                error: function (response) {
                }
            });
            BaseView.prototype.initialize(this);

        },
        render: function () {
            this.$el.html(this.template({}));
            pf.session.getAuth(function () { });
            $(window).scrollTop(0);
            return this;
        },
        saveNickname: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = this;
            var updatedNN = this.$("#nickname").val();
            var lc = new LinkedCard(
               {
                   LGUID: this.EUID,
                   NN: updatedNN
               })

            $.ajax({
                type: 'POST',
                url: pf.consumerURL + "/LinkedCards/Nickname",
                data: JSON.stringify(lc),
                contentType: "application/json",
                success: function (model, resp) {
                    that.NickName = updatedNN;
                    alert("Successfully updated");
                    pf.popupboxclose();
                },
                error: function (model, resp) {
                    jAlert("Error");
                }
            });


            return this;
        },
        finish: function () {
            //TODO: If checkbox checked, flip sub program

            if (!isInApp()) {                

                if (pf.session.get("CardType") != enums.cardTypes.GPRDebitCard && this.$("#getDebitCard").checked) {
                    var that = this;

                    //flip only if Virtual card
                    if (pf.session.get("CardType") != enums.cardTypes.GPRDebitCard) {
                        $.ajax({
                            type: "POST",
                            url: pf.accountsURL + "/ConvertToGPR",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            traditional: true,
                            success: function (response) {
                                if (response) {
                                    pf.session.set({ CardType: enums.cardTypes.GPRDebitCard });
                                    //Navigate to success page
                                    var successView = new SuccessView();
                                    pf.show(successView, "#mainRegion");
                                }
                                else
                                    jAlert("There was an error trying to request a debit card. Please try again")
                            },
                            error: function (resp,model) {
                                if (resp.status == 400)
                                    jAlert("There was an error trying to request a debit card. Please try again")
                            },
                            done: function (response) {
                                if (response) {
                                    pf.session.set({ CardType: enums.cardTypes.GPRDebitCard });
                                    //Navigate to success page
                                    var successView = new SuccessView();
                                    pf.show(successView, "#mainRegion");
                                }
                                else
                                    jAlert("There was an error trying to request a debit card. Please try again")
                            }
                        });
                    }
                    else {
                        var successView = new SuccessView();
                        pf.show(successView, "#mainRegion");
                    }
                }
                else
                    pf.navigate("wallet");
            }
        },
        close: function () {
        }
    });
});

